var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.2857 10.7612H1.71432C1.51908 10.7612 1.35718 10.5993 1.35718 10.404C1.35718 10.2088 1.51908 10.0469 1.71432 10.0469H10.2857C10.481 10.0469 10.6429 10.2088 10.6429 10.404C10.6429 10.5993 10.481 10.7612 10.2857 10.7612Z",
    fill: "#006355"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.34272 1.94205C8.41891 1.01824 7.51415 0.994429 6.56653 1.94205L5.99034 2.51824C5.94272 2.56586 5.92368 2.64205 5.94272 2.70872C6.30463 3.97062 7.31415 4.98014 8.57606 5.34205C8.5951 5.34681 8.61415 5.35157 8.6332 5.35157C8.68558 5.35157 8.7332 5.33252 8.77129 5.29443L9.34272 4.71824C9.81415 4.25157 10.0427 3.79919 10.0427 3.34205C10.0475 2.87062 9.81891 2.41348 9.34272 1.94205Z",
    fill: "#006355"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71919 5.77554C7.5811 5.70887 7.44776 5.64221 7.31919 5.56602C7.21443 5.50411 7.11443 5.43744 7.01443 5.36602C6.93348 5.31363 6.83824 5.23744 6.74776 5.16125C6.73824 5.15649 6.70491 5.12792 6.66681 5.08983C6.50967 4.95649 6.33348 4.78506 6.17634 4.59459C6.16205 4.58506 6.13824 4.55173 6.10491 4.50887C6.05729 4.45173 5.97634 4.35649 5.90491 4.24697C5.84776 4.17554 5.7811 4.07078 5.71919 3.96602C5.643 3.83744 5.57634 3.70887 5.50967 3.57554C5.443 3.43268 5.39062 3.29459 5.343 3.16602L2.35253 6.15649C2.29062 6.2184 2.23348 6.33744 2.21919 6.4184L1.96205 8.24221C1.91443 8.56601 2.00491 8.87078 2.20491 9.07554C2.37634 9.24221 2.61443 9.33268 2.87157 9.33268C2.92872 9.33268 2.98586 9.32792 3.043 9.3184L4.87157 9.06125C4.95729 9.04697 5.07634 8.98982 5.13348 8.92792L8.12395 5.93744C7.99062 5.88982 7.86205 5.83744 7.71919 5.77554Z",
    fill: "#006355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a8e6a66ae9152cd894f4de7b9a7fdd20.svg";
export { ForwardRef as ReactComponent };